import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printTable } from '../../output.js'

export const environmentsListCommand = new Command(`list`)
  .usage(`--project <id>`)
  .description(`List environments in a project`)
  .requiredOption(`--project <id>`, `Project ID`)
  .action(async (opts) => {
    const json = environmentsListCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.environments.list({ projectId: opts.project })

      if (isQuiet()) {
        for (const e of result.environments) {
          printQuiet(e.id)
        }
        return
      }

      if (json) {
        printJson(result)
      } else {
        printTable(
          [`ID`, `Name`, `Created`],
          result.environments.map((e) => [
            e.id,
            e.name,
            e.createdAt.slice(0, 10),
          ])
        )
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
